import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_monitor_the_working_hours_of_all_wrkrs_und_the_age'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_monitor_the_working_hours_of_all_wrkrs_und_the_age',
  name: 'Does the facility monitor the working hours of all workers under the age of 18 separately?',
  description:
    'The intent of this question is to understand if the facility (regardless of what the law states) monitors the working hours of young workers SEPARATELY from adult workers. \r\r\n \r\r\n"Monitoring" refers to the process of reviewing / checking working hours to make sure they are within legal (or other) requirements.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'cl-4--11',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4610,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
